// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader-module--loader--2ACWq","dot":"Loader-module--dot--pHyBq","slide":"Loader-module--slide--1Do10","reveal":"Loader-module--reveal--LZVLR"};